import * as O from "fp-ts/lib/Option";

export const positiveNonZeroNumberO = (a: number): O.Option<number> => a > 0 ? O.some(a) : O.none;

export const abbreviate = (n: number): string => n > 999 ? n % 1000 === 0 ? (n / 1000).toFixed(0) + "k" : (n / 1000).toFixed(1) + "k" : `${n}`;
